export default __webpack_public_path__ + "static/media/Anna 9781408327999.c64768de.jpg";